var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoteHeaderIcon = function SvgVoteHeaderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 62,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.343,
    height: 43.28,
    x: 13.324,
    y: 6.3,
    fill: "url(#VoteHeaderIcon_svg__a)",
    rx: 2.902,
    transform: "rotate(-15 13.324 6.3)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 78.23,
    height: 53.181,
    x: -5.805,
    y: 14.448
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.9px)",
      clipPath: "url(#VoteHeaderIcon_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 5.805,
    filter: "url(#VoteHeaderIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.622,
    height: 41.572,
    y: 20.253,
    fill: "#D3DDFF",
    fillOpacity: 0.47,
    rx: 5.224
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.622,
    height: 41.572,
    y: 20.253,
    fill: "url(#VoteHeaderIcon_svg__d)",
    fillOpacity: 0.2,
    rx: 5.224
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.331,
    height: 41.282,
    x: 0.145,
    y: 20.398,
    stroke: "url(#VoteHeaderIcon_svg__e)",
    strokeWidth: 0.29,
    rx: 5.079
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#VoteHeaderIcon_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m36.709 51.698-2.347-3.178q-1.043.21-2.033.21-2.58 0-4.745-1.208a9.15 9.15 0 0 1-3.415-3.361q-1.251-2.18-1.251-4.886t1.251-4.859a9.15 9.15 0 0 1 3.415-3.361q2.164-1.209 4.745-1.209t4.718 1.209a8.7 8.7 0 0 1 3.39 3.361q1.25 2.154 1.25 4.86.001 2.363-.964 4.333a8.8 8.8 0 0 1-2.633 3.23l4.015 4.86zM27.48 39.275q0 2.443 1.304 3.914 1.33 1.444 3.545 1.444 2.19 0 3.493-1.47 1.33-1.471 1.33-3.888 0-2.442-1.33-3.887-1.303-1.47-3.493-1.47-2.216-.001-3.545 1.444-1.305 1.444-1.304 3.913"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "VoteHeaderIcon_svg__a",
    x1: 25.496,
    x2: 25.496,
    y1: 6.3,
    y2: 49.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B77E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00288D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VoteHeaderIcon_svg__d",
    x1: 33.311,
    x2: 33.311,
    y1: 32.943,
    y2: 61.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#638FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#638FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VoteHeaderIcon_svg__e",
    x1: 4.602,
    x2: 68.509,
    y1: 13.251,
    y2: 66.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "VoteHeaderIcon_svg__c",
    width: 78.23,
    height: 53.181,
    x: -5.805,
    y: 14.448,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.490385 0 0 0 0 0.575321 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_10491_14604"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "VoteHeaderIcon_svg__f",
    width: 23.831,
    height: 26.496,
    x: 20.596,
    y: 27.525,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10491_14604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10491_14604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "VoteHeaderIcon_svg__b",
    transform: "translate(5.805 -14.448)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.622,
    height: 41.572,
    y: 20.253,
    rx: 5.224
  })))));
};
export default SvgVoteHeaderIcon;